import React from 'react';
import { Box, Container, Grid, Typography } from '@mui/material';
import { TrendingUp } from '@mui/icons-material';

const statistics = [
  {
    country: 'India',
    flag: '🇮🇳',
    passRate: '95.2%',
    students: '50,000+',
    description: 'Highest passing rate in FMGE among all countries',
  },
  {
    country: 'Bangladesh',
    flag: '🇧🇩',
    passRate: '42.8%',
    students: '8,500+',
    description: 'Similar curriculum to India, high FMGE success rate',
  },
  {
    country: 'Nepal',
    flag: '🇳🇵',
    passRate: '38.5%',
    students: '4,200+',
    description: 'Growing number of successful FMGE candidates',
  },
  {
    country: 'Russia',
    flag: '🇷🇺',
    passRate: '25.7%',
    students: '12,000+',
    description: 'Strong medical education with FMGE coaching support',
  },
  {
    country: 'China',
    flag: '🇨🇳',
    passRate: '18.3%',
    students: '15,000+',
    description: 'Increasing FMGE preparation and support systems',
  },
];

const FMGEStatistics = () => {
  return (
    <Box sx={{ py: 8, bgcolor: 'primary.main', color: 'white' }}>
      <Container maxWidth="xl">
        <Typography
          variant="h2"
          align="center"
          sx={{ mb: 2, fontSize: { xs: '1.8rem', md: '2.5rem' } }}
        >
          FMGE{' '}
          <Box component="span" sx={{ color: '#D4A853' }}>
            Statistics
          </Box>
        </Typography>
        <Typography
          variant="h6"
          align="center"
          sx={{ mb: 6, opacity: 0.8 }}
        >
          Foreign Medical Graduate Examination passing percentages by country
        </Typography>

        <Grid container spacing={4}>
          {statistics.map((stat, index) => (
            <Grid item xs={12} sm={6} md={4} lg={2.4} key={index}>
              <Box
                sx={{
                  textAlign: 'center',
                  p: 4,
                  borderRadius: 4,
                  bgcolor: 'rgba(255,255,255,0.1)',
                  backdropFilter: 'blur(10px)',
                  transition: 'all 0.3s',
                  '&:hover': {
                    bgcolor: 'rgba(255,255,255,0.2)',
                    transform: 'translateY(-10px)',
                  },
                }}
              >
                <Typography variant="h2" sx={{ mb: 2 }}>
                  {stat.flag}
                </Typography>
                <Typography variant="h6" sx={{ mb: 1, fontWeight: 600 }}>
                  {stat.country}
                </Typography>
                <Typography
                  variant="h3"
                  sx={{ fontWeight: 700, color: '#D4A853', mb: 1 }}
                >
                  {stat.passRate}
                </Typography>
                <Typography variant="body2" sx={{ mb: 2, opacity: 0.8 }}>
                  Pass Rate
                </Typography>
                <Box
                  sx={{
                    width: '100%',
                    height: 8,
                    bgcolor: 'rgba(255,255,255,0.2)',
                    borderRadius: 4,
                    mb: 2,
                    overflow: 'hidden',
                  }}
                >
                  <Box
                    sx={{
                      width: stat.passRate,
                      height: '100%',
                      bgcolor: '#D4A853',
                      borderRadius: 4,
                    }}
                  />
                </Box>
                <Typography variant="body2" sx={{ opacity: 0.7 }}>
                  {stat.description}
                </Typography>
              </Box>
            </Grid>
          ))}
        </Grid>
      </Container>
    </Box>
  );
};

export default FMGEStatistics;